import { apiAxios } from "@aeo/core/api/axios";

export const approvals = {
  sign: async (id: number) => {
    return apiAxios.patch(`/aeo/approvals/${id}/sign`);
  },
};
